import { render, staticRenderFns } from "./roomCalculation.vue?vue&type=template&id=17920260&scoped=true"
import script from "./roomCalculation.vue?vue&type=script&lang=js"
export * from "./roomCalculation.vue?vue&type=script&lang=js"
import style0 from "./roomCalculation.vue?vue&type=style&index=0&id=17920260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17920260",
  null
  
)

export default component.exports